/**
 *
 * @param {string} attribute
 * @param {HTMLElement} element
 */
export function toggleBooleanAttribute( attribute, element ) {
    const current_value = element.getAttribute( attribute );
    element.setAttribute( attribute, current_value === 'false' );
}